export default "__VITE_ASSET__32d19236__"